<template lang="pug">
.container
  .title_bar.flex_h.justify-content-center.align-items-center
    svg-icon(
      :iconClass="icon",
      className="icon",
      :class="{ expand: selected }"
    )
    h2.i_mtb_0.i_ml_2 {{ title }}
    svg-icon(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: selected }"
    )
</template>

<script>
export default {
  name: "ExpandHead",
  props: {
    title: String,
    icon: String,
    selected: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/expand_head";
</style>
